export default __webpack_public_path__ + "static/media/paperFlat.789cf8e1.jpg";